import {
  AuthIdpConsts,
  DirectoryGroupingConsts,
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import RadiusMFAValues from 'client/util/Constants/RadiusMFA';
import RadiusServerApi from 'client/api/v2/RadiusServerApi';
import createModel from 'client/store/modules/models/createModel';

const { groupTypes } = DirectoryGroupingConsts;

export const getDefaultItem = () => ({
  authIdp: AuthIdpConsts.idpProviderValues.Jumpcloud,
  caCert: '',
  mfa: RadiusMFAValues.disabled,
  name: '',
  networkSourceIp: '',
  sharedSecret: '',
  _id: '',
  userPasswordEnabled: true,
  userCertEnabled: false,
  deviceCertEnabled: false,
});

const model = createModel(getDefaultItem, '_id', RadiusServerApi);

const updateIdpBeforeSave = (authIdp) => (
  authIdp === AuthIdpConsts.idpProviderValues.Azure
    ? AuthIdpConsts.Azure
    : authIdp
);

export default {
  namespaced: true,

  state: {
    ...model.state,
  },

  actions: {
    ...model.actions,

    saveItem(context) {
      return model
        .actions.saveItem(context)
        .then((item) => {
          const action = `${StoreModuleMap[ItemTypeConsts.radiusServer]}/refreshCollection`;
          context.dispatch(action, { item }, { root: true });
          return item;
        });
    },

    bindRadiusServerToUserGroups(context = { dispatch: () => {} }) {
      return context.dispatch('bindAssociations', {
        parentType: ItemTypeConsts.radiusServer,
        targetType: groupTypes.userGroup,
      });
    },

    updateAuthIdp(context, updatedAuthIdp) {
      const { previousItem } = context.getters;
      const newItem = {
        ...context.state.item,
        authIdp: updatedAuthIdp,
        mfa: updatedAuthIdp === AuthIdpConsts.idpProviderValues.Azure
          ? RadiusMFAValues.disabled
          : previousItem.mfa,
      };

      context.commit('SET_ITEM', newItem);
    },

    prepareItemBeforeSave(context) {
      const { state: { item: { authIdp } } } = context;

      const newItem = {
        ...context.state.item,
        authIdp: updateIdpBeforeSave(authIdp),
      };

      context.commit('SET_ITEM', newItem);
    },
  },

  getters: {
    ...model.getters,

    authIdp(state) {
      const { authIdp } = state.item;
      const updatedIdpName = authIdp === AuthIdpConsts.Azure
        ? AuthIdpConsts.idpProviderValues.Azure
        : authIdp;

      return updatedIdpName;
    },

    /**
     * @todo Remove this in favor of making the AsidePanel headerText computed
     * property more robust!
     */
    displayName: (state = { item: {} }) => {
      if (state.item.name === null) return undefined;
      return state.item.name;
    },

    haveAssociationsChanged(state, getters) {
      return model.getters.haveAssociationsChanged(state, getters)([groupTypes.userGroup]);
    },

    isAuthIdpAzure(state) {
      const { authIdp } = state.item;
      return authIdp === AuthIdpConsts.idpProviderValues.Azure;
    },
  },

  mutations: {
    ...model.mutations,
  },
};
